'use strict';

angular.module('ntmApp').factory('ListGrid', ['$timeout', '$rootScope', '$window', '$routeParams', '$templateRequest', 'ListGridStatus', 'CommonHelper', 'ProfileHelper', 'ListGridHelper', 'ListGridSettings', 'ListGridCell', 'ListGridFiter', 'ListGridDataService', 'ListGridActions', 'ListGridConfirmationService', 'ListGridConstants', 'Animation', 'GridService', 'FlashService', 'Utils', 'EditForm', 'FormService', 'UserInfo',
    function ($timeout, $rootScope, $window, $routeParams, $templateRequest, ListGridStatus, CommonHelper, ProfileHelper, ListGridHelper, ListGridSettings, ListGridCell, ListGridFiter, ListGridDataService, ListGridActions, ListGridConfirmationService, ListGridConstants, Animation, GridService, FlashService, Utils, EditForm, FormService, UserInfo) {

    function ListGrid(type, callback) {

        var self = this;
        var dataService = new ListGridDataService();
        var originalData = {};
        var originalRecord = {};
        var userData = null;

        UserInfo.GetUserInfo().then(function (user) {
            userData = user;
        });

        self.editForm = {};
        self.sectionData = {};
        self.type = type.name;
        self.mode = ListGridConstants.Mode.NONE;
        self.filters = new ListGridFiter();
        self.cell = new ListGridCell();
        self.actions = new ListGridActions(type, callback);

        self.stopEvent = function (event) {
            event.stopPropagation();
        };

        self.getGridData = function ($scope, data, onlyRefreshData) {

            if (onlyRefreshData) {

                ListGridStatus.grid.gridOptions.data = data.grid;

            } else {
                self.sectionData = data;
                self.sectionData.editType = self.sectionData.editType || ListGridConstants.EditType.DIALOG;

                if (self.sectionData.editType === ListGridConstants.EditType.INLINE && self.sectionData.columAnimations) {
                    self.cell.animation = new Animation(userData);
                    self.cell.animation.initAnimation(self.sectionData.columAnimations);
                }

                updateGridStatus($scope);

                self.grid = ListGridStatus.grid;

                self.isInstructionsOverflowed = ListGridHelper.hasContentMoreThenOneLine(ListGridStatus.grid.instructions, '100%');
          }

            ListGridStatus.htmlPageId = data.htmlPageId;

            return ListGridStatus.grid;
        };

        self.trustAsHtml = function (html) {
            return ListGridHelper.trustAsHtml(html);
        };

        self.addNewRecord = function (emptyRow) {

            self.mode = ListGridConstants.Mode.ADD;

            originalData = angular.copy(self.grid.gridOptions.data);

            var row = emptyRow || ListGridHelper.createEmptyRecord();

            ListGridHelper.convertToGridData(row, self.gridData.infoTabModel);

            switch (self.sectionData.editType) {

                case ListGridConstants.EditType.INLINE:

                    self.actions.rowActions.editedRow = null;

                    ListGridHelper.toggleFilterDisabling(true);                    

                    self.grid.gridOptions.data.unshift(row);

                    if (ListGridStatus.gridApi) {

                        ListGridStatus.gridApi.dragndrop.setDragDisabled(true);

                        if (ListGridStatus.gridSettings.grouping.hasGrouping()) {
                            ListGridStatus.gridSettings.grouping.expandJustAddedRow(ListGridStatus.gridApi);

                        }
                    }                    

                    $timeout(function () {
                        self.actions.rowActions.editedRow = ListGridStatus.gridApi.grid.rows[0];
                        self.actions.rowActions.editedRow.addRecord = true;
                        ListGridStatus.gridApi.core.scrollTo(
                          ListGridStatus.grid.gridOptions.data[0],
                          ListGridStatus.grid.gridOptions.columnDefs[0]
                       );
                    }, 50);

                    break;

                case ListGridConstants.EditType.DIALOG:

                    var data = dataService.getEditDialogData(ListGridConstants.Operation.INSERT, self.sectionData, true, row);
                    var editDialog = Utils.OpenModal('', 'ng1/src/listGrid/views/editDialogForm.html', 'listGridEditDialogController', data, 'edit-setup-modal');

                    data.refreshGridData = function (resultData, editMode) {

                        ListGridHelper.convertToGridData(row, resultData.data);

                        if (editMode === ListGridConstants.Operation.INSERT) {
                            self.grid.gridOptions.data.unshift(row);
                            ListGridStatus.originalGridData = angular.copy(ListGridStatus.grid.gridOptions.data);

                            if (ListGridStatus.gridApi) {
                                ListGridStatus.gridApi.grouping.setGrouping(ListGridStatus.gridApi.grouping.getGrouping());
                            }
                        }

                        if (self.profileCallback) {
                            self.profileCallback(resultData, self.selectedProfileMenuItem);
                        }
                    };

                    data.addNew = function () {
                        $timeout(function () {
                            var emptyRow = ListGridHelper.createEmptyRecord(true, row);
                            self.addNewRecord(emptyRow);
                        }, 1000);
                    };

                    data.deleteRow = function () { self.deleteRow({ entity: row }, editDialog); };
                    data.runAction = function (button, dialogModel) { self.actions.rowActions.startAction(button, { entity: row }, dialogModel); };

                    break;
            }
        };

        self.addGroupRecord = function (row) {
            var emptyRow = ListGridStatus.gridSettings.grouping.getSampleRowData(row);
            ListGridStatus.gridSettings.grouping.expandRows(ListGridStatus.gridApi, row);
            self.addNewRecord(emptyRow);
        };

        self.saveAndAddNew = function () {
            self.save(true);
        };

        self.editRow = function (row) {

            self.mode = ListGridConstants.Mode.EDIT;

            self.actions.rowActions.editedRow = row;

            originalRecord = angular.copy(row.entity);

            originalData = angular.copy(self.grid.gridOptions.data);

            switch (self.sectionData.editType) {

                case ListGridConstants.EditType.INLINE:

                    row.editRecord = true;

                    ListGridHelper.toggleFilterDisabling(true);
                    ListGridStatus.gridApi.dragndrop.setDragDisabled(true);

                    ListGridStatus.columns.forEach(function (column) {
                        self.cell.processDependencies(row, column);
                    });

                    break;

                case ListGridConstants.EditType.DIALOG:

                    var data = dataService.getEditDialogData(ListGridConstants.Operation.EDIT, self.sectionData, true, row.entity, self.actions);        
                    
                    var editDialog = Utils.OpenModal('', 'ng1/src/listGrid/views/editDialogForm.html', 'listGridEditDialogController', data, 'edit-setup-modal');

                    data.refreshGridData = function (resultData) {

                        ListGridHelper.convertToGridData(self.actions.rowActions.editedRow.entity, resultData.data);

                        if (self.profileCallback) {
                            self.profileCallback(resultData, self.selectedProfileMenuItem);
                        }
                    };

                    data.addNew = function () {
                        $timeout(function () {
                            var emptyRow = ListGridHelper.createEmptyRecord(true, row.entity);
                            self.addNewRecord(emptyRow);
                        }, 1000);
                    };

                    data.deleteRow = function () { self.deleteRow(row, editDialog); };
                    data.runAction = function (button, dialogModel) { self.actions.rowActions.startAction(button, row, dialogModel); };

                    break;
            }

        };

        self.deleteRow = function (row, dialog) {

            var calback = function () {

                var form = new EditForm({
                    action: ListGridConstants.Operation.DELETE,
                    pageType: ListGridConstants.SectionType.Grid,
                    mdPage: ListGridStatus.htmlPageId,
                    model: dataService.getModel(row.entity),
                    generalPageSection: [{
                        mdPage: self.sectionData.sectionId,
                        sectionAttributes: ListGridStatus.columns
                    }]
                });

                form.SaveData().then(function (result) {
                    if (result.success) {
                        ListGridStatus.grid.gridOptions.data.splice(ListGridStatus.grid.gridOptions.data.indexOf(row.entity), 1);
                        ListGridStatus.originalGridData = angular.copy(ListGridStatus.grid.gridOptions.data);

                        if (ListGridStatus.gridSettings.dragging.getSequenceField()) {
                            updateSequences(row.entity, ListGridStatus.grid.gridOptions, true);
                        } else {
                            if (result.data && result.data.message) {
                                FlashService.Success(result.data.message);
                            }
                        }

                        if (dialog) {
                            dialog.dismiss();
                        }

                        if (self.profileCallback) {
                            self.profileCallback(result.data, self.selectedProfileMenuItem);
                        }

                        self.actions.rowActions.clearSelection();
                        
                    }
                });
            };

            ListGridConfirmationService.DeleteWarning()
                                                .Yes(calback)
                                                .Ask();
        };

        self.save = function (addNew, url, callback, newItem) {

            self.editForm = new EditForm({
                action: self.mode,
                entity: self.actions.rowActions.editedRow.entity,
                doNotReset: true,
                pageType: ListGridConstants.SectionType.Grid,
                mdPage: ListGridStatus.htmlPageId,
                model: dataService.getModel(self.actions.rowActions.editedRow.entity),
                generalPageSection: [{
                    mdPage: self.sectionData.sectionId,
                    sectionAttributes: ListGridStatus.columns
                }]
            });

            if (originalRecord) {
                self.editForm.originalModel = dataService.getModel(originalRecord);
            }

            self.editForm.SaveData().then(function (result) {
                if (result.success) {

                    ListGridHelper.convertToGridData(self.actions.rowActions.editedRow.entity, result.data.data);

                    self.mode = ListGridConstants.Mode.NONE;
                    self.inlineDataChanged = false;
                    self.actions.rowActions.editedRow.editRecord = false;
                    self.actions.rowActions.editedRow.addRecord = false;
                    ListGridHelper.toggleFilterDisabling(false);
                    ListGridStatus.gridApi.dragndrop.setDragDisabled(false);
                    originalRecord = null;
                    ListGridStatus.gridApi.grouping.setGrouping(ListGridStatus.gridApi.grouping.getGrouping());
                    ListGridStatus.originalGridData = angular.copy(ListGridStatus.grid.gridOptions.data);

                    if (addNew) {
                        $timeout(function () {
                            var emptyRow = ListGridHelper.createEmptyRecord(true, self.actions.rowActions.editedRow.entity);
                            self.addNewRecord(emptyRow);
                        }, 1000);
                       
                    }
                    if (url) {
                        $window.location.href = url;
                    }

                    if (callback) {
                        callback(newItem);
                    }

                    if (self.profileCallback) {
                        self.profileCallback(result.data, self.selectedProfileMenuItem);
                    }
                   
                }
            });            
        };

        self.cancel = function () {
            self.mode = ListGridConstants.Mode.NONE;
            self.actions.rowActions.editedRow.editRecord = false;
            self.actions.rowActions.editedRow.addRecord = false;
            self.inlineDataChanged = false;
            ListGridHelper.toggleFilterDisabling(false);
            ListGridStatus.gridApi.dragndrop.setDragDisabled(false);
            self.grid.gridOptions.data = angular.copy(originalData);
        };

        self.areContactsReadOnly = function() {
            return CommonHelper.IsCayuseOneLogin(userData) && $routeParams.id === ListGridConstants.oneLogin.contactsPageID;
        };


        //private methods

        function closeActionDropdownOnScroll() {
            $timeout(function () {
                angular.element(document.querySelector('.ui-grid-viewport')).bind('scroll', function () {
                    ListGridStatus.gridApi.core.getVisibleRows().forEach(function (row) {
                        row.closeDropdown = false;
                    });
                });
            }, 500);
        }

        function getRowTemplate() {

            if (type === ListGridConstants.Types.Dashboard) {
                return ListGridStatus.gridSettings.conditions.hasConditions() ? ListGridStatus.gridSettings.conditions.getRowTemplate() : $templateRequest('ng1/src/listGrid/views/dasboardRowTemplate.html');
            }

            if (type === ListGridConstants.Types.Setup) {
                return $templateRequest('ng1/src/listGrid/views/setupRowTemplate.html');
            }
        }

        function updateGridStatus($scope) {
            ListGridStatus.htmlPageId = ProfileHelper.pageId;
            ListGridStatus.gridSettings = new ListGridSettings(self.sectionData.gridOptions, self.sectionData.preferences);
            ListGridStatus.columns = self.sectionData.columns;
            ListGridStatus.actions = self.sectionData.actions;
            ListGridStatus.gridId = self.sectionData.sectionId;
            ListGridStatus.grid = prepareGridOptions($scope);

            if (ListGridHelper.doesGridContainRoomHistory()) {
                ListGridStatus.originalGridData = angular.copy(ListGridStatus.grid.gridOptions.data); 
                ListGridStatus.grid.gridOptions.data = ListGridHelper.getFilteredRoomHistoryRecords(ListGridStatus.originalGridData, false);
            }
        }

        function prepareGridOptions($scope) {
            var data = {};
            var columnDefs = getColumnDefs();

            data.header = self.sectionData.header;
            data.cluetip = self.sectionData.cluetip;
            data.instructions = self.sectionData.instructions; 
            data.canInsert = self.sectionData.canInsert;
            data.addButtonName = self.sectionData.addButtonName;

            data.canEdit = self.sectionData.canEdit;
            data.canDelete = self.sectionData.canDelete;
            data.maxWidth = ListGridStatus.gridSettings.maxWidth;
            

            data.gridOptions = ListGridHelper.getDefaultOptions(type);
            data.gridOptions.data = self.sectionData.grid;
            data.gridOptions.columnDefs = columnDefs;
            data.gridOptions.rowTemplate = getRowTemplate();

            data.gridOptions.onRegisterApi = function (gridApi) {

                ListGridStatus.gridApi = gridApi;
                ListGridStatus.gridApi.columnDefs = columnDefs;

                ListGridStatus.gridApi.dragndrop.setDragDisabled(!ListGridStatus.gridSettings.dragging.isDraggable());

                ListGridStatus.gridSettings.grouping.expandRow(ListGridStatus.gridApi);

                ListGridStatus.gridApi.draggableRows.on.rowDragged($scope, function () {
                    resetGrid();
                });

                ListGridStatus.gridApi.draggableRows.on.rowDropped($scope, function (info) {
                    if (ListGridStatus.gridSettings.grouping.isValidDrop(info)) {
                        updateSequences(info.draggedRowEntity, data.gridOptions);
                    } else {
                        Utils.OpenModal('Cannot resequence to another group', 'ng1/src/common/alertPopup.html', null, { title: 'Cannot resequence', action: 'close' });
                    }
                });

                ListGridStatus.gridApi.core.on.columnVisibilityChanged($scope, function () {
                    ListGridStatus.gridSettings.preferences.changePreferences(ListGridStatus.gridApi.columnDefs);
                });

                ListGridStatus.gridApi.core.on.clearFilter($scope, function () {
                    $rootScope.clearGridFilters = true;
                    $timeout(function () {
                        $rootScope.clearGridFilters = false;
                    }, 50);
                });

                if (self.editDialogData) {

                    $timeout(function () {
                        var row = ListGridHelper.getGridRecord(ListGridStatus.gridApi.grid.rows, self.editDialogData.key, self.editDialogData.value);

                        if (row.entity) {
                            self.editRow(row);
                        }

                        
                        self.editDialogData = null;
                    }, 50);
                }
                

            };

            closeActionDropdownOnScroll();

            return data;
        }

        function updateSequences(entity, gridOptions, deletingRow) {
            var sequence = 1;
            var data = { id: self.sectionData.sectionId, data: [], field: ListGridStatus.gridSettings.dragging.getSequenceField() };
            var column = ListGridHelper.getColumnByFieldName(ListGridStatus.gridSettings.dragging.getSequenceField());

            if (column) {
                var children = ListGridStatus.gridSettings.grouping.getGroupChildren(entity, gridOptions.data);
                children.forEach(function (record) {
                    record[column.name] = sequence;

                    var item = {
                        primaryKeys: ListGridHelper.getPrimaryKeys(record, 'name'),
                        value: record[column.name]
                    };
                    data.data.push(item);

                    sequence++;
                });

                if (data.data.length > 0) {
                    var loading = FlashService.Loading();
                    GridService.UpdateSequences(data).then(function (result) {
                        loading.dismiss();
                        if (!deletingRow) {
                            FlashService.Success(result.data.message);
                        }
                        originalData = angular.copy(gridOptions.data);
                    });
                }
            }
        }

        function resetGrid() {
            ListGridStatus.gridApi.grid.clearAllFilters();
            ListGridStatus.columns.forEach(function (column) {
                if (ListGridStatus.gridSettings.dragging.compareSequenceField(column.fieldName)) {
                    ListGridStatus.gridApi.grid.sortColumn(column.name);
                }
            });
        }

        function hideActionColumn() {
            return ListGridStatus.gridSettings.grouping.hasGrouping() ||
                   type === ListGridConstants.Types.Dashboard && ListGridStatus.actions.rowActions.length === 0 ||
                   self.areContactsReadOnly(); 
        }

        function initSearchableData() {

            self.sectionData.searchableData.navigate = function (next, record) {

                if (record) {

                    self.actions.rowActions.editedRow = ListGridStatus.gridApi.grid.rows.filter(function (item) {
                        return item.entity[self.sectionData.searchableData.searchable] === record.value;
                    })[0];
                } else {

                    var rows = ListGridStatus.gridSettings.grouping.getGroupRows(ListGridStatus.gridApi.grid, self.actions.rowActions.editedRow);
                    var i = 0;

                    rows.forEach(function (item, index) {
                        if (item.entity.$$hashKey === self.actions.rowActions.editedRow.entity.$$hashKey) {
                            if (next) {
                                i = index >= rows.length - 1 ? 0 : index + 1;
                            } else {
                                i = index === 0 ? rows.length - 1 : index - 1;
                            }
                        }
                    });

                    self.actions.rowActions.editedRow = rows[i];
                }

                self.actions.rowActions.selectRow(self.actions.rowActions.editedRow);

                return dataService.getModel(self.actions.rowActions.editedRow.entity);
            };
        }

        function getColumnDefs() {

            var definitions = [];

            if (!hideActionColumn()) {
                definitions.push(ListGridHelper.getActionColumn());
            }

            self.sectionData.columns.forEach(function (column) {
				
				column.propertyObj = column.properties ? JSON.parse(column.properties) : {};

				ListGridHelper.processingGridData(column, self.sectionData.grid);

				if (!column.isHide && !column.hideInGrid) {
                    self.cell.columnDependencies.init(column.fieldName, column.propertyObj.dependent);

                    var item = self.cell.getCellSettings(column, self.sectionData.columnMinWidth, self.sectionData.editType === ListGridConstants.EditType.DIALOG);

                    if (self.sectionData.editType === ListGridConstants.EditType.INLINE) {
                        self.cell.setInlineCellTemplate(column, item);
                    }

                    if (self.sectionData.editType === ListGridConstants.EditType.DIALOG) {
                        self.cell.setDialogCellTemplate(column, item);
                    }

                    ListGridStatus.gridSettings.grouping.processingGrouping(column, item);

                    self.filters.buidFilter(column, item, self.sectionData.grid);

                    if (column.searchable) {

                        self.sectionData.searchableData = ListGridHelper.getSearchableData(column, self.sectionData.grid);

                        initSearchableData();
                    }

                    definitions.push(item);
                }
            });

            return definitions;
        }

        $rootScope.$on('resizeGridEvent', function () {
            if (ListGridStatus.gridApi) {
                ListGridStatus.gridApi.core.handleWindowResize();
            }
        });

        angular.element($window).bind('resize', function () {
            self.isInstructionsOverflowed = ListGridHelper.hasContentMoreThenOneLine(ListGridStatus.grid.instructions, '100%'); 
        });
    }

    return (ListGrid);
}]);
